"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileConnectSuccessCallback = void 0;
var react_router_dom_1 = require("react-router-dom");
var react_use_1 = require("react-use");
var hooks_1 = require("./hooks");
var ProfileConnectSuccessCallback = function () {
    var _a = (0, hooks_1.useUserIdentityReturnUrlStorage)(), returnUrl = _a[0], clearReturnUrl = _a[2];
    var history = (0, react_router_dom_1.useHistory)();
    (0, react_use_1.useMount)(function () {
        clearReturnUrl();
        history.replace(returnUrl);
    });
    return null;
};
exports.ProfileConnectSuccessCallback = ProfileConnectSuccessCallback;
//# sourceMappingURL=ProfileConnectSuccessCallback.js.map